import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SearchBar from '../Components/SearchBar'
import { Form, FormControl } from 'react-bootstrap';
import env from '../ENV';
import {connect} from 'react-redux'
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import SuccessFailureModal from '../Components/Success_Failure_Modal_forDispatch';
import authInstance from '../Classes/AuthHandler';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import formatDate from '../Classes/FormatDate'
import { GetDispatchMaterialPO} from '../store/actions/dispatchOrderDetailsActions'
import {UpdateDispatchStatus} from '../store/actions/orderNoActions'
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'

const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

// function formatDate(date) {
//     var d = new Date(date),
//     month = '' + (d.getMonth() + 1),
//     day = '' + d.getDate(),
//     year = d.getFullYear();
//     if (month.length < 2) 
//     month = '0' + month;
//     if (day.length < 2) 
//     day = '0' + day;
//     return [day, month, year].join('-');
//   }
  
  class DispatchMaterialPOItem extends React.Component {

    constructor(props) {
        super(props);
        this.state={
        PONumber: this.props.location.state.poId,
        PurchaseOrderId: this.props.location.state.PurchaseOrderId,
        allChecked: false,
        supplierName: "ABC Tech Inc.",
        select: true,
        checkbox:false,
        open: false,
        checked: [],
        selected:[],
        dispatchData:[],
        checkedArray:[],
        opacity:"",
        comments:'',
        formattedData: [],
        selectAll: false,
        modal: false,
        modalLogistics:false,
        lorryreceiptmodal:false,
        multiCollapseIndex:"",
        datevalue:"",
        // array2: [
        //     {  value: 1, id:1, PoNo: "4700026943", PoName: "ABC" , PoItem: "10" , PoDate: "12-06-2020" , status: "Documents has been Approved",statusLogistics: "Documents has been Approved", WBSNo: "A0XXXX", totalPoQuantity: "50" , quantityToDispatch: "" , itemDescription: "STAND TILTING DEVICE" , dispatchConditions: "DAP", arrangeTransport: "SMS", proposedDate: "" },
        //     {  value: 2, id:2, PoNo: "4700026943", PoName: "ABC" , PoItem: "11" , PoDate: "11-01-2020" , status: "Documents has been Approved",statusLogistics: "Transporter has been assigned", WBSNo: "A0XXX0", totalPoQuantity: "90" , quantityToDispatch: "" , itemDescription: "TRANSFER DEVICE, CROSS" , dispatchConditions: "EXW", arrangeTransport: "Supplier", proposedDate:  ""},
        //     {  value: 3, id:3, PoNo: "4700026943", PoName: "ABC" , PoItem: "12" , PoDate: "12-03-2020" , status: "Documents has been Approved",statusLogistics: "Documents has been Approved", WBSNo: "AQUXXX", totalPoQuantity: "100", quantityToDispatch: "" , itemDescription: "TOP FRAME" ,   dispatchConditions: "DAP", arrangeTransport: "Supplier", proposedDate: ""  },
        //     {  value: 4, id:4, PoNo: "4700026943", PoName: "ABC" , PoItem: "13" , PoDate: "01-08-2020" , status: "Documents has been Approved",statusLogistics: "Transporter has been assigned", WBSNo: "A0YAAX", totalPoQuantity: "145", quantityToDispatch: "" , itemDescription: "LOOSE SLIDE" , dispatchConditions: "EXW", arrangeTransport: "SMS", proposedDate: ""},
        // ]       
      }
      // this.dateformate = this.dateformate.bind(this);
      this.modal= this.modal.bind(this);
      this.modalLogistics= this.modalLogistics.bind(this);
      this.comments = this.comments.bind(this);
      this.togglebutton = this.togglebutton.bind(this); 
      // this.toggleSuccessModalLogistics = this.toggleSuccessModalLogistics.bind(this); 
      this.handleChange = this.handleChange.bind(this);
      this.handleSingleCheckboxChange = this.handleSingleCheckboxChange.bind(this);
      this.lorryreceiptmodal=this.lorryreceiptmodal.bind(this);
      
    }
    
    
    modal() {
      this.setState({ modal: !this.state.modal });
      if(this.state.lorryreceiptmodal==true){
        this.setState({ lorryreceiptmodal: !this.state.lorryreceiptmodal });
        }
        if(this.state.modal ==true){
          this.setState(
            {opacity:""}
            )
          }
          else{
              this.setState(
                {opacity:"0.2"} 
                )}}
                
                
                modalLogistics() {
      this.setState({ modalLogistics: !this.state.modalLogistics });
      if(this.state.lorryreceiptmodal==true){
        this.setState({ lorryreceiptmodal: !this.state.lorryreceiptmodal });
      }
      if(this.state.modalLogistics ==true){
        this.setState(
          {opacity:""}
          )
        }
        else{
          this.setState(
            {opacity:"0.2"} 
            )}}
            
    lorryreceiptmodal() {
      this.setState({ lorryreceiptmodal: !this.state.lorryreceiptmodal });
      
          if(this.state.lorryreceiptmodal ==true){
            this.setState(
              {opacity:""}
              )
            }
            else{
              this.setState(
                  {opacity:"0.2"} 
                  )}}
 
                  action1() {
                    this.setState({ action1: false });
                  } 
                  
                  togglebutton=(Index)=> {  
                    var multiCollapseIndex = this.state.multiCollapseIndex
                    if(multiCollapseIndex!=Index || multiCollapseIndex==''){
        this.setState({multiCollapseIndex:Index})
      }}
      
      handleDispatchMaterial =() =>{
        console.log(this.state.dispatchData, '#####')
        this.state.dispatchData.map((element) => {         
          this.props.UpdateDispatchStatus(element.POId,element.PurchaseOrderLineId,element.ProposedDate, element.DispatchCondition)
        })
        window.location.reload()
      }
      
    handleChange = () => {   
      var selectAll = !this.state.selectAll;
      this.setState({ selectAll: selectAll });
      var checkedCopy = [];
      this.state.array2.map(function(e, index) {
        checkedCopy.push(selectAll);
      });
      this.setState({
        checked: checkedCopy
      });
    };
    
    handleSingleCheckboxChange = (index,element) => {
      var checkedArray = this.state.checkedArray
      let selected = this.state.selected;
      let status = index in selected ? !selected[index] : true
      selected[index] = status
      let inputData = this.state.dispatchData
      if(selected[index]==true){
          checkedArray.push(index)
          inputData.push({
            "POSAPId": element.POSAPId,
            "POLineIteamSAPId": element.POLineItemSAPCode,
            "POId": element.PurchaseOrderId,
            "PurchaseOrderLineId": element.PurchaseOrderLineId,
            "DispatchCondition": element.incoTerms,
            "Transporter": element.incoTerms == "DAP" ? "Supplier" : "SMS",
            "ProposedDate": this.state.datevalue,
            "LineItemQuantity": element.POLineItemQuantity,
            "WBSNO": element.WBSCode,
            "LineItemDescription": element.POLineItemDescription
          })
      }else{
          var index1 = checkedArray.indexOf(index);
          var inputindex = inputData.findIndex(i => i.PurchaseOrderLineId === index);
          console.log(index,inputindex,index1,"++++++")
          if (index1 !== -1 && inputindex !== -1) {
              checkedArray.splice(index1, 1);
              inputData.splice(inputindex, 1);
          }
      }
      this.setState({selected,checkedArray,dispatchData:inputData});
      console.log(inputData,"_________________")
    };
    
   
    toggleSuccessModal(e){
      this.setState({ modal: !this.state.modal });
      if(this.state.modal ==true){
        this.setState(
          {opacity:""}
          )}
    else{
      this.setState(
        {opacity:"0.2"} 
        ) }
      }
      
      toggleSuccessModalLogistics(e){
        this.setState({ modalLogistics: !this.state.modalLogistics });
        if(this.state.modalLogistics ==true){
          this.setState(
            {opacity:""}
          )}
          else{
            this.setState(
              {opacity:"0.2"} 
              ) }
            }
            
            comments(event) { 
              this.setState({comments: event.target.value})
        // console.log(this.state.comments,"comments") ;
      }
      
      
      // handleClick = () => {
        //   var datePattern= document.getElementById('myDate').value;
      //   document.getElementById("demo").innerHTML=datePattern;
      //   console.log(document.getElementById("demo").innerHTML,";;;;;;;")
      // }
      handleChangeDate = (e) =>{
        console.log(e.target.value,"'''''''''''''''''''")
        this.setState({datevalue:e.target.value})
      }
      
      componentDidMount(){
        var UserId= authInstance.getUserPayLoad().userId
        var RoleId = Object.keys(authInstance.getRoles())[0]
        // console.log(UserId,"''''''")
          this.props. GetDispatchMaterialPO(UserId,RoleId,this.state.PurchaseOrderId)
      }
      
      render()
      {
        var roles = authInstance.getRoles()
        var groups = authInstance.getGroups()
        console.log(roles)
        console.log(this.props.orderDetails.allOrderDetails.recordset,"=======")
        return(
          
          <div className="Container-fluid pageheight"  >
               {/* ---------Upload Lorry Receipt Modal Start-------- */}

               <Modal isOpen={this.state.lorryreceiptmodal} >
                <div className={"modal-bg" + (this.state.lorryreceiptmodal === 'false'  ? 'open' : '')}>
                  <div className="modalheads">
                  <ModalHeader HeaderStyle="modal-header modalheaderWide2">
                    <div><h4 >Upload Lorry Receipt</h4></div>
                    <button type="button" className="close" aria-label="Close" onClick={this.lorryreceiptmodal} >
                         <span aria-hidden="true">&times;</span>
                    </button>
                 </ModalHeader>
                  </div>
                    <div >
                <ModalBody Style="modal-body modalbodysWide2">
                 <div className="row ml-2 pt-2 ">
                        <div className="col-md-6 pt-2 " >
                            <div className="row">
                                <div className="col" ><b>PO No. :</b></div> 
                                <div className="col">{this.state.PONumber}</div>    
                            </div>
                        
                        </div>
                        <div className="col-md-6 pt-2">
                            <div className="row">
                                    <div className="col" ><b>PO Item No. :</b></div> 
                                    <div className="col ">ABC</div>    
                                </div>
                            </div>
                 </div>

                 <div className="row ml-2 pt-2 ">
                        <div className="col-md-6 pt-2 " >
                            <div className="row">
                                <div className="col" ><b>PO Date :</b></div> 
                                <div className="col">ABC</div>    
                            </div>
                        
                        </div>
                        <div className="col-md-6 pt-2">
                            <div className="row">
                                    <div className="col" ><b>PO Quantity :</b></div> 
                                    <div className="col ">ABC</div>    
                                </div>
                            </div>
                 </div>

                 <div className="row ml-2 pt-2 ">
                        <div className="col-md-6 pt-2 " >
                            <div className="row">
                                <div className="col" ><b>WBS No. :</b></div> 
                                <div className="col">ABC</div>    
                            </div>
                        
                        </div>
                        <div className="col-md-6 pt-2">
                            <div className="row">
                                    <div className="col" ><b>Location :</b></div> 
                                    <div className="col ">ABC</div>    
                                </div>
                            </div>
                 </div>
                 <div className="row ml-2 pt-2">
                       <div className="col-md-3"><b>Comments <em>(if any)</em> :</b></div> 
                       <div className="col-md-7">
                         <textarea className="form-control" rows="2" value={this.state.comments} onChange={this.comments}></textarea>
                         </div>
                   </div>               
                </ModalBody>
                </div>
                <div>    
                <ModalFooter FooterStyle="modal-footer modalfooterWide2">
                <div>            
                {/* {roles[13] ?
                <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={this.modalLogistics} type="submit">Confirm</button> : */}
                <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={this.modal} type="submit">Confirm</button>
                {/* } */}
                  <button className="btn2 btn-sms3 mt-2 ml-4 float-right" onClick={this.lorryreceiptmodal} type="submit">Cancel</button>
               </div>
              </ModalFooter>
                </div>
                </div>
                </Modal>
                {/* ---------Upload Lorry Receipt Modal End-------- */}


               <div className="Container-fluid p-4" >
                <div className="row pr-4" >
                    <div className="col-md-8  ">
                      {/* for purchase teams */}
                    {/* {roles[15]  ?<>     
                    <Link  to ={{ pathname: '/DispatchDocumentsDashboard',state : { PONumber:this.state.PONumber} }}>     
                    <button className=" btn2 btn-sms1  rounded float-right mr-4" type="submit" onClick={this.lorryreceiptmodal} > Dispatch Material </button> 
                    </Link>
                  </>:<></>}  */}
                  {/* for tpm */}
                  {/* {roles[12]  ?<>     
                    <Link  to ={{ pathname: '/DashboardTPM',state : { PONumber:this.state.PONumber} }}>     
                    <button className="btn2 btn-sms1 mr-4 mt-2 float-right" type="submit" > Dispatch Material </button> 
                    </Link>
                  </>:<></>}  */}
                  {/* for supplier */}
                  {roles[5] ?<>               
                    {/* <Link  to ={{ pathname: '/DispatchDocumentsDashboard',state : { PONumber:this.state.PONumber} }}> 
                    <button className=" btn2 btn-sms1 mt-2 rounded float-right mr-2" type="submit" > Upload Dispatch Documents </button>
                    </Link> */}
                    <button className=" btn2 btn-sms1 mt-2 rounded float-right mr-2" type="submit" onClick={this.handleDispatchMaterial} > Dispatch Material </button>
                  </>:<></>} 
                  {/* for logistics team */}
                  {roles[13] ?<> 
                    <Link  to ={{ pathname: '/DispatchArrangePOItem',state : { PONumber:this.state.PONumber} }}>     
                    <button className=" btn2 btn-sms1 mt-2 rounded float-right mr-2" type="submit"
                    //  onClick={this.lorryreceiptmodal} 
                     > Arrange Transport </button> 
                    </Link>
                  </>:<></> }
                  </div>
                    
                    <div className="col pt-2  xs={last}">
                    <SearchBar placeholder="Search"  label="Search"  btnName=""  />
                    </div>
                </div>
                <div>
                <SuccessFailureModal action={this.state.modal} toggleSuccessModal={(e)=>this.toggleSuccessModal(e)}
                  headertitle="Successful" text="PO Item: 10,11 has been dispatched successfully. " icon='check-circle' iconcolor="green"   FooterButton="Request Payment" path='/TestModal' />
                </div>

                <div>
                <SuccessFailureModal action={this.state.modalLogistics} toggleSuccessModalLogistics={(e)=>this.toggleSuccessModalLogistics(e)}
                  headertitle="Successful" text="PO Item: 10,11 has been dispatched successfully. " icon='check-circle' iconcolor="green" FooterButton="OK " path='/TestModal' />
                </div>
              <div className="row-md-8 pr-4">
                <div className="col ">
                  {/* for supplier */}
                  {roles[5]?<>
                    <div className="row  headerbar ">
                   
                          <div className="col-md-1 pt-2 pb-2 checkboxheaderbar borderheaderbar">
                            <input type="checkbox" onChange={() => this.handleChange()} checked={this.state.selectAll}/>                           
                          </div>
                           <div className="col-md-2 pt-2 pb-2 borderheaderbar">PO Number</div>
                           <div className="col-md-1 pt-2 pb-2 borderheaderbar ">PO Item</div>
                           <div className="col-md-2 pt-2 pb-2 borderheaderbar d-none d-sm-block">PO Date</div>
                           <div className="col-md-3 pt-2 pb-2 borderheaderbar">Status</div>
                           <div className="col-md-3 pt-2 pb-2 borderheaderbar">Proposed Date </div>
                           
                    </div></>
                    
                    :
                    // for purchase team
                    roles[15]?<>

                    <div className="row  headerbar ">
                   
                          {/* <div className="col-md-1 pt-2 pb-2 checkboxheaderbar borderheaderbar">
                            <input type="checkbox" onChange={() => this.handleChange()} checked={this.state.selectAll}/>                           
                          </div> */}
                           <div className="col-md-2 pt-2 pb-2 borderheaderbar">PO Number</div>
                           <div className="col-md-2 pt-2 pb-2 borderheaderbar ">PO Item</div>
                           <div className="col-md-2 pt-2 pb-2 borderheaderbar d-none d-sm-block">PO Date</div>
                           <div className="col-md-3 pt-2 pb-2 borderheaderbar">Status</div>
                           <div className="col-md-3 pt-2 pb-2 borderheaderbar ">Action</div>
                           
                    </div></>
                    :
                    roles[13]?<>
                    <div className="row  headerbar ">
                   
                      <div className="col-md-2 pt-2 pb-2 borderheaderbar">PO Number</div>
                      <div className="col-md-3 pt-2 pb-2 borderheaderbar ">PO Item</div>
                      <div className="col-md-3 pt-2 pb-2 borderheaderbar d-none d-sm-block">PO Date</div>
                      <div className="col-md-3 pt-2 pb-2 borderheaderbar">Status</div>
                      
                    
                   </div>
                    </>
                    :<>
                    <div className="row  headerbar ">
                   
                   {/* <div className="col-md-1 pt-2 pb-2 checkboxheaderbar borderheaderbar">
                     <input type="checkbox" onChange={() => this.handleChange()} checked={this.state.selectAll}/>                           
                   </div> */}
                    <div className="col-md-2 pt-2 pb-2 borderheaderbar">PO Number</div>
                    <div className="col-md-2 pt-2 pb-2 borderheaderbar ">PO Item</div>
                    <div className="col-md-2 pt-2 pb-2 borderheaderbar d-none d-sm-block">PO Date</div>
                    <div className="col-md-3 pt-2 pb-2 borderheaderbar">Status</div>
                    <div className="col-md-3 pt-2 pb-2 borderheaderbar ">Action</div>
                    
                    </div>
                    </>
                  }

                        {this.props.orderDetails.getAllPoForDispatchMaterial && this.props.orderDetails.getAllPoForDispatchMaterial.recordset && this.props.orderDetails.getAllPoForDispatchMaterial.recordset.length>0 &&this.props.orderDetails.getAllPoForDispatchMaterial.recordset.map((element,Index)=>
                            <div className={Index%2==0? 'row border ':'row  background '} 
                             onClick={()=>this.togglebutton(Index)} data-toggle="collapse" data-target={`.multi-collapse${Index}`}>
                                {/* for supplier */}
                             {roles[5]?<>
                                    <div className="col-md-1 pt-2 pb-2 borderheaderbar"> 
                                        <input type="checkbox" checked={this.state.selected && this.state.selected.length >0 && this.state.selected[element.PurchaseOrderLineId] && this.state.selected[element.PurchaseOrderLineId] == true ? true:false} onChange={(event) => this.handleSingleCheckboxChange(element.PurchaseOrderLineId,element)} value=""/>  
                                        {/* <input key={element.id} type='checkbox' name={element.POSAPId} value={element.POSAPId} checked={this.state.checked[Index]} onChange={() => this.handleSingleCheckboxChange(Index)} />         */}
                                    </div>
                                    <div className="col-md-2 pt-2 pb-2 borderheaderbar headeralign">{element.POSAPId}</div>
                                    
                                    <div className="col-md-1 pt-2 pb-2 borderheaderbar amount-text headeralign">{element.POLineItemSAPCode}</div>
                                    <div className="col-md-2 pt-2 pb-2 borderheaderbar d-none d-sm-block">{dateFormater(element.PODeliveryDate)}</div>
                                   
                                      {/* <div className="col-md-3 pt-2 pb-3 borderheaderbar ">
                                      <Form.Control type="date" onChange={(e) => {this.handleDate(e, element, Index)}} id={`proposedDate-datepicker-${element.PurchaseOrderId}-${element.PurchaseOrderLineId}`} name={`proposedDate-datepicker-${element.PurchaseOrderId}-${element.PurchaseOrderLineId}`} name="proposedDate" placeholder="Proposed Date" />
                                      </div> */}
                                      <div className="col-md-3 pt-2 pb-2 borderheaderbar headeralign">{element.dispatchStatusName}</div>
                                    <div className="col-md-3 pt-2 pb-2 borderheaderbar headeralign ">
                                      <input type='date' id="myDate" value={this.state.datevalue} onChange={this.handleChangeDate} />
                                      {/* <button onClick={this.handleClick} className='btn-border'> <p id="demo"></p></button>                        */}
                                    </div>
                                    </>
                                :
                                // for purchase team
                                roles[15]?<>

                                    <div className="col-md-2 pt-2 pb-1 borderheaderbar headeralign">{element.POSAPId}</div>
                                   
                                    <div className="col-md-2 pt-2 pb-2 borderheaderbar amount-text headeralign">{element.POLineItemSAPCode}</div>
                                    <div className="col-md-2 pt-2 pb-2 borderheaderbar d-none d-sm-block">{dateFormater(element.PODeliveryDate)}</div>
                                    <div className="col-md-3 pt-2 pb-3 borderheaderbar headeralign">{element.dispatchStatusName}</div>
                                    <div className="col-md-3 pt-2 pb-2 borderheaderbar amount-text headeralign">
                                    <Link  to ={{ pathname: '/DashboardTPM',state : { PurchaseOrderId: element.PurchaseOrderId, PurchaseOrerLineId: element.PurchaseOrderLineId, checked : element} }}>
                                      <FontAwesomeIcon icon={"eye"} color={"black"} title="View" size="lg"  />
                                    </Link>
                                    </div>
                                  
                                    </>
                                    :
                                    // for logistics team
                                    roles[13]?
                                      <>
                                        <div className="col-md-2 pt-2 pb-2 borderheaderbar headeralign">{element.POSAPId}</div>
                                        <div className="col-md-3 pt-2 pb-2 borderheaderbar amount-text headeralign">{element.POLineItemSAPCode}</div>
                                        <div className="col-md-3 pt-2 pb-2 borderheaderbar d-none d-sm-block">{dateFormater(element.PODeliveryDate)}</div>
                                        <div className="col-md-3 pt-2 pb-2 borderheaderbar headeralign">{element.dispatchStatusName}</div>
                                        
                                      </>
                                    : <>
                                    <div className="col-md-2 pt-2 pb-2 borderheaderbar headeralign">{element.POSAPId}</div>
                                   
                                   <div className="col-md-2 pt-2 pb-2 borderheaderbar amount-text headeralign">{element.POLineItemSAPCode}</div>
                                   <div className="col-md-2 pt-2 pb-2 borderheaderbar d-none d-sm-block">{dateFormater(element.PODeliveryDate)}</div>
                                   <div className="col-md-3 pt-2 pb-2 borderheaderbar headeralign">{element.dispatchStatusName}</div>
                                   <div className="col-md-3 pt-2 pb-2 borderheaderbar amount-text headeralign">
                                   <Link  to ={{ pathname: '/DispatchDocumentsDashboard',state : { PONumber:element.POSAPId,PoItem: element.POLineItemSAPCode,WBSNo:element.WBSCode} }}>
                                       <FontAwesomeIcon icon={"eye"} color={"black"} title="View" size="lg"  />
                                   </Link>
                                   </div>
                                   </>
                              }
                      
                         <div className={Index==this.state.multiCollapseIndex ? ` pt-2 mb-2 detailpanebackground container collapse multi-collapse${Index}` : `container collapse` }> 
                                  <form>
                                        <div></div>
                                           <div className="row">
                                              <div className="col-md-3">
                                                  <b>WBS No: </b>
                                               </div>
                                               <div className="col">
                                                {element.WBSCode}
                                                </div>
                                                
                                               <div className="col-md-3">
                                                 <b>Total LineItem Quantity: </b>
                                               </div>
                                               <div className="col">
                                                {element.POLineItemQuantity+ " " + element.OrderUnit}
                                               </div>
                                            </div>
                                            <br />
                                            <div className="row">
                                                <div className="col-md-3">
                                                  <b>Quantity to Dispatch: </b>
                                                </div>
                                                <div className="col">
                                                NA
                                                </div>
                                                
                                                <div className="col-md-3">
                                                 <b>Item Description: </b>
                                                </div>
                                                <div className="col">
                                                {element.POLineItemDescription}
                                                </div>
                                            </div> 
                                            <br />
                                            <div className="row">
                                                <div className="col-md-3">
                                                  <b>Dispatch Conditions: </b>
                                                </div>
                                                <div className="col">
                                                {element.incoTerms}
                                                </div>
                
                                                <div className="col-md-3">
                                                    <b>Arrange Transport: </b>
                                                </div>
                                                <div className="col">
                                                {element.incoTerms == "DAP" ? "Supplier" : "SMS"}
                                                </div>
                                                </div> 
                                                <br />

                                              
                                              <br />
                                   </form> 
                             </div>
                          </div>
                          )}  
                        <br/> 
                        <br/>
                  
                  
                  </div>
  
            </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps  = (state) => ({orderDetails:state.orderDetails})
export default connect(mapStateToProps,{GetDispatchMaterialPO,UpdateDispatchStatus}) (DispatchMaterialPOItem);

// export default DispatchMaterialPOItem;